<template>
  <div class="tsa-pagerV2">
     <div class="pages">
        <el-select v-model="pageSizesValue" placeholder="请选择" @change="change" v-if="selectRender" popper-class="tsa-pagerV2-select">
            <el-option
                v-for="item in pageSizes"
                    :key="item"
                    :label="item + t('el.pager.pagesize')"
                    :value="item">
                </el-option>
        </el-select>
    </div>
    <a class="pre iconStyle tsa-icon-arrow-left2" @click="pre" :class="currentPage === 1 ? 'disabled' : ''" href="javascript:;"></a>
    <ul>
        <li v-for="(item, index) in pagesList" :key="index">
            <a :class="[currentPage === item ? 'active' : '', item === '...' ? 'normal' : '']" @click="pageChange(item)" href="javascript:;">{{ item }}</a>
        </li>
    </ul>
    <a class="next iconStyle tsa-icon-arrow-right2" @click="next" :class="nextDisabled ? 'disabled' : ''" href="javascript:;"></a>
    <div class="jump">
        <p>跳转至</p>
        <div class="input-container">
            <input type="number" :value="jumpPageValue" min="1" :max="maxPage" @blur="blur($event)" @keydown.enter="blur($event)" ref="input">
            <p @click="jump">GO</p>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Locale from 'tsa-ui/src/mixins/locale';
export default {
  name: 'TsaPager',
  props: {
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 5
        },
        pageSizes: {
            type: Array,
            default: () => {
                return [10, 20, 30, 100]
            }
        }
    },
    data () {
        return {
            pageSizesValue: this.pageSizes[0],
            jumpPageValue: '1',
            selectRender: true,
        }
    },
    mixins: [Locale],
    watch: {
        currentPage (value) {
            this.jumpPageValue = value
        },
        pageSize (val) {
            this.selectRender = false
            setTimeout(() => {
                this.selectRender = true
                this.pageSizesValue = val
            })
        }
    },
    computed: {
        pagesList () {
            let pages = Math.ceil(this.total/this.pageSize)
            if (pages <= 10) return pages
            if (this.currentPage <= 5) {
                return [1, 2, 3, 4, 5, 6, '...', pages]
            } else if (this.currentPage >= pages - 5) {
                return [1, '...', pages-6, pages-5, pages-4, pages-3, pages-2, pages-1, pages]
            } else {
                return [1, '...', this.currentPage-2, this.currentPage-1, this.currentPage, this.currentPage+1 ,this.currentPage+2, '...', pages]
            }
        },
        maxPage () {
            return this.total === 0 ? 1 : Math.ceil(this.total/this.pageSize)
        },
        nextDisabled () {
            let pages = Math.ceil(this.total/this.pageSize)
            if (this.currentPage === pages) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        blur (e) {
            let value = e.target.value
            let newValue = parseInt(e.target.value)
            if (value) {
                if (this.jumpPageValue == newValue) return
                if (newValue > this.maxPage) {
                    newValue = this.maxPage
                } else if (newValue < 1) {
                    newValue = 1
                }
            } else {
                newValue = 1
            }
            // 强制清空
            this.$refs.input.value = newValue.toString()
            this.$emit('update:currentPage', newValue)
            this.$emit('current-change', newValue)
        },
        jump () {

        },
        change () {
            this.$emit('update:currentPage', 1)
            this.$emit('size-change', this.pageSizesValue)
        },
        pageChange (item) {
            if (this.currentPage === item) return
            if (item === '...') return
            this.$emit('update:currentPage', item)
            this.$emit('current-change', item)
            
        },
        // 上一页面
        pre () {
            if (this.currentPage === 1) return
            let currentPage = this.currentPage - 1
            this.$emit('update:currentPage', currentPage)
            this.$emit('current-change', currentPage)
        },
        // 下一页面
        next () {
            if (this.nextDisabled) return
            let currentPage = this.currentPage + 1
            this.$emit('update:currentPage', currentPage)
            this.$emit('current-change', currentPage)
        }
    }
};
</script>
<style lang="less" scoped>

.tsa-pagerV2 {
    a {
        display: block;
        text-decoration: none;
    }
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #FFFFFF;
    .total {
        margin-right: 10px;
        color: #2468F2;
        font-size: 14px;
        font-weight: normal;
    }
    ul {
        display: flex;
        align-items: center;
        list-style: none;
        li {
            a {
                padding: 0 7px;
                border-radius: 4px;
                color: #151B26;
                font-size: 14px;
                line-height: 30px;
                min-width: 32px;
                box-sizing: border-box;
                text-align: center;
                border: 1px solid #FFFFFF;
                &:hover {
                    color: #1F5EFF;
                }
                &.active {
                    color: #2468F2;
                    background-color: #FFFFFF;
                    border: 1px solid #2468F2;
                    border-radius: 4px;
                }
                &.normal {
                    cursor: default;
                }
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    .pre {
        border-radius: 4px;
        font-size: 16px;
        line-height: 32px;
        // width: 32px;
        // height: 32px;
        margin-right: 8px;
        color: #D8D8D8;
        text-align: center;
        &:hover {
            color: #2468F2;
        }
        &.disabled {
            cursor: not-allowed;
            &:hover {
                 color: #D8D8D8;
            }
        }
    }
    .next {
        border-radius: 4px;
        font-size: 16px;
        line-height: 32px;
        // width: 32px;
        // height: 32px;
        margin-right: 8px;
        color: #D8D8D8;
        text-align: center;
        &:hover {
             color: #2468F2;
        }
        &.disabled {
            cursor: not-allowed;
            &:hover {
                 color: #D8D8D8;
            }
        }
    }
    .pages {
        display: flex;
        align-items: center;
        width: 100px;
        text-align: center;
        height: 24px;
        // background-color: #F0F5FF;
        border-radius: 31px;
        margin-right: 8px;
        justify-content: flex-end;
        /deep/.el-select {
            flex: 1;
            .el-input {
                width: 100%;
                .el-input__inner {
                    font-size: 14px;
                    color: #151B26;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #D4D6D9;
                }
                .el-input__suffix {
                    
                    .el-select__caret {
                        color: #151B26;
                        line-height: 32px;
                    }
                }
            }
        }
    }
    .jump {
        display: flex;
        align-items: center;
        > p {
            font-size: 14px;
            color: #84868C;
            margin-right: 16px;
        }
        .input-container {
            display: flex;
            align-items: center;
            height: 32px;
            border-radius: 31px;
            box-sizing: border-box;
            border: 1px solid #E8E9EB;
            border-radius: 4px;
            input {
                // width: 86px;
                font-size: 14px;
                color: #2468F2;
                text-align: center;
                width: 40px;
                background: transparent;
                border: 0;
                &:focus {
                    border: none;
                    outline: none;
                }
            }
            input[type=number] {
                -moz-appearance:textfield;
            }
            input[type=number]::-webkit-inner-spin-button,
            input[type=number]::-webkit-outer-spin-button {
                -webkit-appearance: none;
                margin:0 ;
            }
            p {
                cursor: pointer;
                width: 32px;
                text-align: center;
                line-height: 30px;
                flex-shrink: 0;
                font-size: 14px;
                color: #151B26;
                text-align: center;
                border-left: 1px solid #E8E9EB;
            }
        }
    }
}


</style>